import React from 'react';
import { useTranslation } from 'react-i18next';
import { INVOICE_STATUSES } from '../../consts/consts';
import { getNumOfOverdueDays, isUnsentOverdueInvoice } from '../../utils';
import Icon from '../../../../../generic-components/Icon';
import { getDueDateNoticeText, getDueDateNoticeTextStyle } from './utils';
import { greenStatusIcon, pendingIcon, redStatusIcon } from '../../../../../assets/svg';

interface IDueDateNotice {
  dueDate: string,
  status: string,
  paidTime?: string,
}

const DueDateNoticeStyles = {
  Icon: 'inline-block mr-[4px] w-[12px] h-[12px]',
  Wrapper: 'flex items-center',
};

export const DueDateNotice = ({ dueDate, status, paidTime }: IDueDateNotice) => {
  const { t } = useTranslation();
  const numOfOverdueDays = getNumOfOverdueDays(dueDate);
  const getDueDateNoticeIconSrc = () => {
    if (isUnsentOverdueInvoice(status, numOfOverdueDays)) return redStatusIcon;
    if (status === INVOICE_STATUSES.PAYMENT_PENDING) return pendingIcon;
    if (status === INVOICE_STATUSES.PAID) return greenStatusIcon;
    return null;
  };

  const text = getDueDateNoticeText(status, numOfOverdueDays, t, paidTime);
  const style = getDueDateNoticeTextStyle(status);
  const icon = getDueDateNoticeIconSrc();
  if (!text) return null;

  return (
    <div className={DueDateNoticeStyles.Wrapper}>
      {icon && <Icon className={DueDateNoticeStyles.Icon} src={icon} />}
      {text && <span className={style}>{text}</span>}
    </div>
  );
};
